<template>
  <div class="live-tag">
    <i class="fa-solid fa-circle live-dot"></i>
    <span class="title-small-semibold">En Direct</span>
  </div>
</template>
<style scoped>
.live-tag {
  display: flex;
  align-items: center;
  gap: 8px;
}
.live-dot {
  color: #cb0e0e;
}
</style>
